import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createElement } from 'react';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
export const ProfessionalRfpProposalListStatus = (props) => {
    const { children, icon, iconColor = 'base', textColor = 'base' } = props;
    return (_jsxs(IconTextGroup, Object.assign({ className: 'text-[15px]' }, { children: [createElement(icon, { color: iconColor, size: 'current' }), _jsx(Text, Object.assign({ color: textColor, isBold: false, size: 'sm' }, { children: children }))] })));
};
